import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/LOGO_NEWTEC_CLOUD_ICONE_2.png'
import _imports_1 from '../../assets/images/home/system333.png'
import _imports_2 from '../../assets/images/home/system3333.png'


const _withScopeId = n => (_pushScopeId("data-v-4a023a16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header color-container-branco navbar navbar-expand-lg navbar-sticky navbar-stuck position-absolute navbar-sticky z-index-header" }
const _hoisted_2 = { class: "container px-3 d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "me-2",
    src: _imports_0,
    width: "40",
    alt: "Layer"
  }),
  /*#__PURE__*/_createElementVNode("h4", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Newtec Cloud")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<li class=\"pointer d-flex align-items-center\" data-v-4a023a16><a class=\"style-link\" href=\"#SectionQuemSomos\" data-v-4a023a16>Quem somos</a></li><li class=\"pointer d-flex align-items-center\" data-v-4a023a16><a class=\"style-link\" href=\"#SectionBeneficios\" data-v-4a023a16>Benefícios</a></li><li class=\"pointer d-flex align-items-center\" data-v-4a023a16><a class=\"style-link\" href=\"#SectionSistema\" data-v-4a023a16>Sistema</a></li><li class=\"pointer d-flex align-items-center\" data-v-4a023a16><a class=\"option-login d-flex\" href=\"/login\" data-v-4a023a16><i class=\"flaticon-user d-flex align-items-center me-2\" data-v-4a023a16></i> Entrar</a></li>", 4)
const _hoisted_8 = [
  _hoisted_4
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("section", { class: "color-container-branco mt-50 position-relative overflow-hidden py-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "container pt-lg-3" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row flex-lg-nowrap" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-xl-5 text-center text-lg-start pt-5 mt-xl-4" }, [
          /*#__PURE__*/_createElementVNode("h1", { class: "display-4 pt-5 pb-2 pb-lg-3 mt-sm-2 mt-lg-5 title-home-page" }, "Centralize suas gravações na nuvem"),
          /*#__PURE__*/_createElementVNode("p", { class: "fs-18 mb-4 mb-lg-5" }, "Somos a melhor empresa para armazenar e cuidar das suas gravações tudo por um preço acessível."),
          /*#__PURE__*/_createElementVNode("a", {
            href: "/register",
            class: "btn btn-primary btn-lg mt-40"
          }, [
            /*#__PURE__*/_createTextVNode(" Comece agora "),
            /*#__PURE__*/_createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "aria-hidden": "true",
              role: "img",
              class: "bx fs-xl ms-2",
              width: "1em",
              height: "1em",
              viewBox: "0 0 24 24"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                fill: "currentColor",
                d: "m11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707l-1.414 1.414L15.586 11H6v2h9.586z"
              })
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "pt-50 mt-xl-50" }, [
            /*#__PURE__*/_createElementVNode("h6", { class: "pt-xl-3 pb-3 pb-lg-4" }, [
              /*#__PURE__*/_createElementVNode("strong", null, "Com nosso sistema você pode realizar integração com Smart Sampa")
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "parallax mt-4 ms-4 me-lg-0 ms-lg-n5 ms-xl-n3 mt-lg-n4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "parallax-layer" }, [
            /*#__PURE__*/_createElementVNode("img", {
              src: _imports_1,
              width: "1416",
              alt: "Layer"
            })
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div id=\"SectionQuemSomos\" class=\"container pb-50 pt-50 mb-50 mt-50\" data-v-4a023a16><h1 class=\"border-bottom pb-4\" data-v-4a023a16>Quem somos</h1><div class=\"row pt-2 pt-md-3\" data-v-4a023a16><div class=\"col-md-6\" data-v-4a023a16><p class=\"fs-16 fs-lg pe-lg-4 mb-1 mb-lg-4\" data-v-4a023a16>Somos uma empresa especializada em armazenamento seguro de gravações de de câmera de segurança em nuvem. Nosso objetivo é proporcionar uma solução confiável para que você possa gerenciar, armazenar e acessar suas gravações de maneira eficiente. Com tecnologia de ponta, garantimos a integridade e segurança dos seus dados, permitindo que você se concentre no que realmente importa: o crescimento do seu negócio.</p></div><div class=\"col-md-6 mt-50 mt-sm-50 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0\" data-v-4a023a16><p class=\"fs-16 fs-lg ps-lg-4 mb-1 mb-lg-4\" data-v-4a023a16>Na Newtec, entendemos a importância de cada gravação registrada. Por isso, criamos uma plataforma robusta e segura para o armazenamento de gravações de câmera de segurança em nuvem. Nossa missão é facilitar o acesso e a gestão desses dados, garantindo a segurança e a eficiência que sua empresa merece. Conte conosco para proteger o que é essencial para o seu sucesso.</p></div></div></div><div data-v-4a023a16><section id=\"SectionBeneficios\" class=\"color-container-branco position-relative overflow-hidden py-4\" data-v-4a023a16><div class=\"container mt-50\" data-v-4a023a16><h2 class=\"h1 text-center pb-4 pb-lg-5 fw-bold mb-40\" data-v-4a023a16>Porque armazenar gravações em nuvem</h2><div class=\"row mt-50\" data-v-4a023a16><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-volume\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Escalabilidade</h3><p class=\"fs-sm\" data-v-4a023a16>A capacidade de armazenamento pode ser facilmente ajustada conforme o volume de gravações aumenta, sem a necessidade de investimentos em infraestrutura física.</p></div><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-draft\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Redução de Riscos Legais</h3><p class=\"fs-sm\" data-v-4a023a16>Armazenar gravações em um ambiente seguro em conformidade com regulamentos ajuda a mitigar riscos legais e proteger a empresa em disputas.</p></div><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-lock-1\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Segurança</h3><p class=\"fs-sm\" data-v-4a023a16>Nós oferecemos medidas avançadas de segurança, protegendo os dados contra acesso não autorizado.</p></div><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-money\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Custo-Efetivo</h3><p class=\"fs-sm\" data-v-4a023a16>Reduz os custos com hardware e manutenção, além de permitir pagar apenas pelo espaço de armazenamento utilizado.</p></div><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-secure-shield\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Compliance</h3><p class=\"fs-sm\" data-v-4a023a16>Facilita a conformidade com regulamentações e leis de proteção de dados, mantendo as gravações seguras e acessíveis conforme necessário.</p></div><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-cloud-computing\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Armazenamento Ilimitado</h3><p class=\"fs-sm\" data-v-4a023a16>Oferecemos espaço virtualmente ilimitado para guardar gravações de longo prazo, sem preocupações com a falta de espaço</p></div><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-search\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Facilidade de Busca e Filtragem</h3><p class=\"fs-sm\" data-v-4a023a16>Oferecemos ferramentas avançadas de busca e filtragem, permitindo localizar gravações específicas de forma rápida e eficiente.</p></div><div class=\"area-card-home col-sm-6 col-md-4 col-lg-3 text-center pb-md-2 mb-3 mb-lg-4 mt-30\" data-v-4a023a16><div class=\"bg-secondary rounded-circle-customize p-3 mb-4\" data-v-4a023a16><i class=\"color-blue d-flex fs-25 flaticon-compare\" data-v-4a023a16></i></div><h3 class=\"h5 pb-1 mb-2 fw-bold\" data-v-4a023a16>Automação de Processos</h3><p class=\"fs-sm\" data-v-4a023a16>Você pode configurar nosso sistema, possibilitando limitar o ambiente armazenado</p></div></div></div></section></div>", 2)
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("section", {
    id: "SectionSistema",
    class: "color-container-branco position-relative overflow-hidden py-4 pt-50"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "container pb-2" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "rellax col-md-7" }, [
          /*#__PURE__*/_createElementVNode("img", {
            src: _imports_2,
            class: "d-block mx-auto",
            width: "746",
            alt: "Image"
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "rellax col-md-5 col-xl-4 offset-xl-1 d-flex d-sm-block flex-column" }, [
          /*#__PURE__*/_createElementVNode("h2", { class: "pb-3 pt-2 pt-md-0" }, "Principais funcionalidades"),
          /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled pb-2" }, [
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Integração com Smart Sampa ")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Você pode usar nosso sistema para atender os seus clientes ")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Mosaico de câmeras para visualizar várias câmeras simultaneamente ")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Reprodução de gravações anteriores ou aovivo ")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Mapa de câmeras para visualizar a localização de cada câmera ")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Cadastro de instalações/usuários/câmeras para gerenciar os seus clientes ")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Fácil instalação e configuração ")
            ]),
            /*#__PURE__*/_createElementVNode("li", { class: "d-flex align-items-center pb-1 mb-2" }, [
              /*#__PURE__*/_createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "aria-hidden": "true",
                role: "img",
                class: "bx text-primary fs-xl me-2",
                width: "1em",
                height: "1em",
                viewBox: "0 0 24 24"
              }, [
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10s10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8s8 3.589 8 8s-3.589 8-8 8z"
                }),
                /*#__PURE__*/_createElementVNode("path", {
                  fill: "currentColor",
                  d: "M9.999 13.587L7.7 11.292l-1.412 1.416l3.713 3.705l6.706-6.706l-1.414-1.414z"
                })
              ]),
              /*#__PURE__*/_createTextVNode(" Você escolhe por quanto tempo quer armazenar as gravações de cada câmera ")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("a", {
            href: "/register",
            class: "btn btn-primary"
          }, [
            /*#__PURE__*/_createTextVNode(" Comece agora "),
            /*#__PURE__*/_createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "aria-hidden": "true",
              role: "img",
              class: "bx fs-xl ms-2",
              width: "1em",
              height: "1em",
              viewBox: "0 0 24 24"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                fill: "currentColor",
                d: "m11.293 17.293l1.414 1.414L19.414 12l-6.707-6.707l-1.414 1.414L15.586 11H6v2h9.586z"
              })
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "footer pt-5 pb-4 pb-lg-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container pt-lg-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row pb-5" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 col-lg-4 mt-30" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "fs-sm pb-lg-3 mb-4" }, " Nossa missão como empresa é prestar o melhor serviço de armazenamento de gravações em nuvem e proporcionar uma ótima experiência aos nossos clientes e resolver os problemas físicos de limitação de espaço e também estamos comprometidos em aumentar a satisfação de nossos clientes com os nossos serviços prestados. "),
        /*#__PURE__*/_createElementVNode("form", { class: "" }, [
          /*#__PURE__*/_createElementVNode("label", {
            for: "subscr-email",
            class: "form-label"
          }, "Assine a nossa newsletter"),
          /*#__PURE__*/_createElementVNode("div", { class: "input-group" }, [
            /*#__PURE__*/_createElementVNode("input", {
              id: "subscr-email",
              class: "form-control rounded-start ps-5",
              type: "email",
              required: "",
              "aria-required": "true"
            }),
            /*#__PURE__*/_createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "aria-hidden": "true",
              role: "img",
              class: "fs-lg text-muted position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5",
              width: "1em",
              height: "1em",
              viewBox: "0 0 24 24"
            }, [
              /*#__PURE__*/_createElementVNode("path", {
                fill: "currentColor",
                d: "M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223l-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044L20.002 18H4z"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip position-absolute top-100 start-0" }, " Please provide a valid email address. "),
            /*#__PURE__*/_createElementVNode("button", {
              class: "btn btn-md btn-primary",
              type: "submit"
            }, "Assinar")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 col-lg-7 col-xl-6 offset-xl-2 offset-md-1 pt-4 pt-md-1 pt-lg-0 mt-30" }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "row",
          id: "footer-links"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, [
            /*#__PURE__*/_createElementVNode("div", {
              id: "useful_links",
              class: "d-block",
              "is-nav": "false"
            }, [
              /*#__PURE__*/_createElementVNode("ul", { class: "nav flex-column pb-lg-1 mb-lg-3" }, [
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, "Inicio")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "/login",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, "Logar")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "/register",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, "Registrar-se")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "/forgot-password",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, "Recuperar senha")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "/documentation",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2",
                    target: "_blank"
                  }, "Documentação")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("ul", { class: "nav flex-column mb-2 mb-lg-0" }, [
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, "Termos e Condições")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, "Política de privacidade")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3 col-xl-4 mt-50" }, [
            /*#__PURE__*/_createElementVNode("div", {
              id: "social_links",
              class: "d-block",
              "is-nav": "false"
            }, [
              /*#__PURE__*/_createElementVNode("ul", { class: "nav flex-column mb-2 mb-lg-0" }, [
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, " Facebook")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, " LinkedIn ")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, " Twitter ")
                ]),
                /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    href: "#",
                    class: "nav-link d-inline-block px-0 pt-1 pb-2"
                  }, " Instagram ")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5 col-xl-4 pt-2 pt-lg-0 text-center" }, [
            /*#__PURE__*/_createElementVNode("h6", { class: "mb-2" }, "Contate-nos"),
            /*#__PURE__*/_createElementVNode("a", {
              href: "mailto:contato@newteccloud.com",
              class: "fw-medium"
            }, "contato@newteccloud.com")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "nav d-block fs-xs text-center text-md-start pb-2 pb-lg-0 mb-0" }, "© 2024 Newteccloud. All rights reserved")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("i", {
          class: "ph ph-list fs-30 menu-toggle",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }),
        _createElementVNode("ul", {
          class: _normalizeClass(['style-list', 'd-sm-flex', 'd-lg-flex', 'd-xl-flex', 'd-xxl-flex', { 'active': _ctx.isMenuActive }]),
          id: "mobileMenu"
        }, _hoisted_8, 2)
      ])
    ]),
    _hoisted_9,
    _hoisted_10,
    _hoisted_12,
    _hoisted_13
  ], 64))
}